import { render, staticRenderFns } from "./OptimizedShippingTable.vue?vue&type=template&id=0e9e6f7d&"
import script from "./OptimizedShippingTable.vue?vue&type=script&lang=js&"
export * from "./OptimizedShippingTable.vue?vue&type=script&lang=js&"
import style0 from "./OptimizedShippingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports